interface Props {
  account: any;
  prefix: 'chart' | 'indicator' | 'summary-chart' | 'draggable-indicator';
}

export function makeKeyGridLayout(props: Props) {
  const { account, prefix } = props;
  return `${prefix}/eyJjb250ZW50IjoicmVhY3QtZ3JpZC1sYXlvdXQifQ==/${account.id}`;
}
